import { COLOR } from 'admin/constants/styles';
import styled, { CSSProperties } from 'styled-components';

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(13, 1fr);
  grid-template-rows: 40px auto;
  grid-gap: 3px;
  align-items: center;
  font-weight: bold;
  background: white;
  padding: 5px 10px;
  box-shadow: 0 0 1px 0 rgba(9, 30, 66, 0.31), 0 2px 4px -1px rgba(9, 30, 66, 0.25);
`;

export const TableRow = styled.div<{
  isDisabled?: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(13, 1fr);
  grid-gap: 3px;
  align-items: center;
  background: ${(props) => (props.isDisabled ? COLOR.lightGray : 'white')};
  padding: 5px 10px;
  box-shadow: 0 0 1px 0 rgba(9, 30, 66, 0.31), 0 2px 4px -1px rgba(9, 30, 66, 0.25);
`;

export const TableCell = styled.div<{
  size?: CSSProperties['gridColumn'];
  align?: 'left' | 'center' | 'right';
  fontWeight?: CSSProperties['fontWeight'];
}>`
  grid-column: span ${(props) => props.size || 2};
  text-align: ${(props) => props.align || 'center'};
  word-wrap: break-word;
  font-weight: ${(props) => props.fontWeight || 400};
`;

export const TableWrapper = styled.div`
  background: ${COLOR.superLightGray};
  padding: 10px;
  border-radius: 5px;
  ${TableRow} {
    margin: 3px 0;
  }
`;
